import type { ClientConfigurationItem } from './clientConfigurationSlice';

export const findByParameter = (
	list: ClientConfigurationItem[] | null | undefined,
	parameter: string,
) =>
	Array.isArray(list) ? list.find((c) => c.Parameter === parameter) : undefined;

// null when the user has no row for the parameter or it is not JSON.
export const readSettingValue = (
	list: ClientConfigurationItem[],
	parameter: string,
): unknown => {
	const raw = findByParameter(list, parameter)?.Value;
	if (typeof raw !== 'string') return null;
	try {
		return JSON.parse(raw);
	} catch {
		return null;
	}
};
